'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const WeeklyOutputBarChart = dynamic(
  () => import('./WeeklyOutputBarChart'),
  {
    ssr: false,
    loading: () => (
      <div className="h-56 w-full animate-pulse bg-muted rounded-lg" />
    ),
  }
);

export default function WeeklyOutputChart() {
  return (
    <div className="bg-card border border-border rounded-xl shadow-card p-5 card-hover">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h2 className="text-base font-semibold text-foreground">Daily Task Output</h2>
          <p className="text-xs text-muted-foreground mt-0.5">
            Tasks completed per day · Sprint W35
          </p>
        </div>
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          <span className="flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-sm bg-primary inline-block" />
            Completed
          </span>
          <span className="flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-sm bg-muted-foreground/30 inline-block" />
            Target
          </span>
        </div>
      </div>
      <WeeklyOutputBarChart />
    </div>
  );
}